import { createFeatureSelector } from "@ngrx/store";
import * as fromSideNav from "./side-nav.reducer";

export const selectSideNavState =
  createFeatureSelector<fromSideNav.SideNavState>(
    fromSideNav.sideNavFeatureKey,
  );
